export default __webpack_public_path__ + "media/icons/videos-icon-active-78dbda67.svg";